import { createContext } from 'react';
import type { TPageContentItem } from '@src/types/wysiwyg_editor';
import { TOverlayLocations, TSprungOverlayLocations } from '@src/utils/wysiwyg_editor/contentItemHandleLocations';
import { SpringRef, SpringValue } from '@react-spring/core';
import { TRect } from '@src/types/misc';

export interface ContentSpringLocations {
  frameDomSpringValues: TSprungOverlayLocations;
  frameDomSpringApi: SpringRef<TOverlayLocations>;
  frameViewboxSpringValues: {
    x: SpringValue<number>;
    y: SpringValue<number>;
    height: SpringValue<number>;
    width: SpringValue<number>;
  };
  frameViewboxSpringApi: SpringRef<TRect>;
}

interface State {
  contentItems: Array<TPageContentItem>;
  lastHistoryWalk: null | number;
  layoutTemplateName: string;
  selectedPageContentItem: TPageContentItem | null | undefined;
}
interface Dispatch {
  getItemById: (id: string) => TPageContentItem | void;
  setSelectedPageContentItemId: (id: string | null | undefined) => void;
}

const defaultStateValue = {
  contentItems: [],
  lastHistoryWalk: null,
  layoutTemplateName: '',
  selectedPageContentItem: null
};
const defaultDispatchValue = {
  getItemById: () => null,
  setSelectedPageContentItemId: () => null
};

export const PageContentStateContext = createContext<State>(defaultStateValue);
export const PageContentDispatchContext = createContext<Dispatch>(defaultDispatchValue);
